// @flow

import classnames from 'classnames';
import React from 'react';
import $ from 'jquery';
import { Swipeable } from 'react-swipeable';
import { NavLink } from 'react-router-dom';
import Profile from '../profile';
import tabs from './tabs';
import './navigation.scss';

class Navigation extends React.Component<Props> {
  constructor() {
    super();
    this.state = {
      hideNavBar: false,
      belowTop: false,
    };
    this.profileEventAdded = false;
    this.toggleMainMenu = this.toggleMainMenu.bind(this);
    this.toggleProfileMenu = this.toggleProfileMenu.bind(this);
    this.handleOutsideMenuTouch = this.handleOutsideMenuTouch.bind(this);
    this.closeHamburgerMenu = this.closeHamburgerMenu.bind(this);
    this.hideNavBarOnWindowScroll = this.hideNavBarOnWindowScroll.bind(this);
    this.closeProfileMenuIfNeeded = this.closeProfileMenuIfNeeded.bind(this);
    this.previousScrollTop = 0;
    this.lastScrollDownTop = 0;
  }

  componentDidMount() {
    window.addEventListener('hashchange', this.hideNavBarOnWindowScroll, false);
    window.addEventListener('touchmove', this.hideNavBarOnWindowScroll);
    $(window).scroll(this.hideNavBarOnWindowScroll);
    // This uses the click event instead of touchend because we need to be able to scroll the
    // profile menu
    document.getElementById('pwa-app').addEventListener('click', this.handleOutsideMenuTouch);
    document.getElementById('pwa-app').addEventListener('click', this.closeProfileMenuIfNeeded);
  }

  componentDidUpdate() {
    const { showMainMenu, showProfileMenu } = this.props;
    if (showMainMenu || showProfileMenu) {
      $('body').css('overflow', 'hidden');
    } else {
      $('body').css('overflow', 'auto');
    }
  }

  componentWillUnmount() {
    document.removeEventListener('touchend', this.handleOutsideMenuTouch);
    window.removeEventListener('touchmove', this.hideNavBarOnWindowScroll);
    window.removeEventListener('hashchange', this.hideNavBarOnWindowScroll, false);
    document.getElementById('pwa-app').removeEventListener('click', this.handleOutsideMenuTouch);
    document.getElementById('pwa-app').removeEventListener('click', this.closeProfileMenuIfNeeded);
    $(window).off('scroll', this.hideNavBarOnWindowScroll);
  }

  hideNavBarOnWindowScroll() {
    const currentScrollTop = $(window).scrollTop();
    const navScrollShowLimit = Math.max(this.lastScrollDownTop - 60, 60);
    const maxScroll = Math.max(document.body.scrollHeight - $(window).height(), 21);
    const isScrollingDown = this.previousScrollTop < currentScrollTop;
    const isScrollingUp = this.previousScrollTop > currentScrollTop;
    if ((isScrollingDown && currentScrollTop > 20) ||
      currentScrollTop > maxScroll - 20) {
      this.setState({
        hideNavBar: true,
      });
      this.lastScrollDownTop = currentScrollTop;
    } else if ((
      isScrollingUp &&
      currentScrollTop < navScrollShowLimit
    ) || currentScrollTop <= 20) {
      this.setState({
        hideNavBar: false,
      });
    }
    if (currentScrollTop > 40) {
      this.setState({ belowTop: true });
    } else {
      this.setState({ belowTop: false });
    }
    this.previousScrollTop = currentScrollTop;
  }

  handleOutsideMenuTouch() {
    const { closeHamburgerMenu } = this.props;
    closeHamburgerMenu();
  }

  toggleMainMenu(event) {
    const { showMainMenu, openHamburgerMenu, closeHamburgerMenu } = this.props;
    if (showMainMenu) {
      closeHamburgerMenu();
    } else {
      openHamburgerMenu();
    }
    if (event.nativeEvent) {
      event.nativeEvent.preventDefault();
      event.nativeEvent.stopImmediatePropagation();
    }
  }

  closeHamburgerMenu(event) {
    const {
      closeHamburgerMenu,
    } = this.props;
    closeHamburgerMenu();
    if (event.event) {
      event.event.preventDefault();
      event.event.stopPropagation();
    }
  }

  closeProfileMenuIfNeeded() {
    const {
      showProfileMenu, closeProfileMenu,
    } = this.props;
    if (showProfileMenu) {
      closeProfileMenu();
    }
  }

  toggleProfileMenu(event) {
    const {
      showProfileMenu, openProfileMenu, closeProfileMenu,
    } = this.props;
    if (showProfileMenu) {
      closeProfileMenu();
    } else {
      openProfileMenu();
    }
    if (event.nativeEvent) {
      event.nativeEvent.preventDefault();
      event.nativeEvent.stopImmediatePropagation();
    }
  }

  shouldRenderProfileMenu() {
    const { user } = this.props;
    return user &&
      user.isAuthenticated &&
      user.profiles &&
      user.profiles.length > 0;
  }

  stopPropagation(event) {
    if (event.nativeEvent) {
      event.nativeEvent.stopImmediatePropagation();
    }
  }

  renderCrossSVGElement() {
    return (
      <svg width="30px" height="30px" className="inner-icon" viewBox="0 0 21 21" version="1.1">
        <title>Icon/Hamburger</title>
        <desc>Created with Sketch.</desc>
        <path d="M0,1 L0,0 L21,0 L21,1 L0,1 Z" fill="#b5b5db" className="top-line" />
        <path d="M0,10 L0,9 L21,9 L21,10 L0,10 Z" fill="#b5b5db" className="middle-line" />
        <path d="M0,1 L0,0 L21,0 L21,1 L0,1 Z" fill="#b5b5db" className="bottom-line" />
      </svg>
    );
  }

  renderNavitems(user: any) {
    return (
      <ul className="nav navbar-nav mr-auto">
        {user && user.isAuthenticated && user.termsAccepted ? (
          tabs.map(({
            href, label, iconClass, access,
          }) => {
            if (!!access && !user[access]) {
              return null;
            }
            return (
              <li className="nav-item" key={href}>
                {href.startsWith('http://') ? (
                  <a href={href} rel="noopener noreferrer">
                    <span className={classnames('prs-icon', iconClass)} />
                    {label}
                  </a>
                ) : (
                    // eslint-disable-next-line react/jsx-indent
                    <NavLink exact to={href}>
                      <span className={classnames('prs-icon', iconClass)} />
                      {label}
                    </NavLink>
                    // eslint-disable-next-line indent
                  )}
              </li>
            );
          })
        ) :
          (
            <li className="nav-item">
              <a href="/Account/SignIn">
                Login
              </a>
            </li>
          )}
      </ul>
    );
  }

  render() {
    const { hideNavBar, belowTop } = this.state;
    const { user, showMainMenu, showProfileMenu } = this.props;
    return (
      <React.Fragment>
        <div className={classnames(
          'main-nav-bar',
          { 'hamburger-menu-open': showMainMenu },
          { 'profile-menu-open': showProfileMenu },
        )}
        >
          <Swipeable onSwipedLeft={this.closeHamburgerMenu} delta={75}>
            <div className="full-modal-bg deep-cove-bg">
              <div className="hamburger-menu">
                {this.renderNavitems(user)}
                {user && user.isAuthenticated && user.termsAccepted && (
                  <div className="sign-out">
                    <NavLink exact to="logout">
                      <span className="prs-icon prs-icon-sign-out" />
                      Sign out
                    </NavLink>
                  </div>
                )}
              </div>
            </div>
          </Swipeable>
          {showProfileMenu && (
            <div className="profile-modal-bg" onScroll={this.stopPropagation} />
          )}
          <nav
            className={classnames([
              'inner-nav-bar navbar fixed-top d-flex flex-row justify-content-between align-items-stretch',
              { hide: hideNavBar && !showMainMenu && !showProfileMenu },
              { 'show-bg-color': belowTop && !showProfileMenu },
            ])}
          >
            <button type="button" className="main_nav__button main_nav--menu m-0" onClick={this.toggleMainMenu} onTouchEnd={this.toggleMainMenu}>
              {this.renderCrossSVGElement()}
            </button>
            <div className="main_nav__logo" />
            <button type="button" className="main_nav__button main_nav--user m-0" onClick={this.toggleProfileMenu} onTouchEnd={this.toggleProfileMenu} />
            {this.shouldRenderProfileMenu() && (
              <Profile
                {...this.props}
              />
            )}
          </nav>
        </div>
      </React.Fragment>
    );
  }
}

export default Navigation;
